export const en = {
  'widget.open': 'Open accessibility menu',
  'panel.title': 'Accessibility',
  'panel.close': 'Close accessibility menu',
  'panel.reset': 'Reset settings',
  'panel.profiles': 'Accessibility profiles',
  'panel.poweredBy': 'Powered by Pulxon',
  'panel.activeProfile': '{name} profile is on',
  'panel.statement': 'Accessibility statement',
  'link.newTab': '(opens in a new tab)',
  'section.content': 'Content adjustments',
  'section.visual': 'Visual & navigation aids',
  'section.color': 'Color adjustments',
  'section.tools': 'Additional tools',
  'section.about': 'About {section}',
  'info.profiles': 'A profile turns on several adjustments at once. You can still change each one below.',
  'info.content': 'Change how the text on this page is sized, spaced and styled.',
  'info.visual': 'Help to follow the page: a clear focus outline, reading aids, a bigger cursor, read aloud and an outline of the page.',
  'info.color': 'Change the colors of this page. One contrast mode and one saturation mode can be on at a time.',
  'info.tools': 'Calm the page down, or get help with words and images.',
  'feature.biggerText': 'Bigger text',
  'feature.highlightLinks': 'Highlight links',
  'feature.tooltips': 'Tooltips',
  'feature.pauseAnimations': 'Stop animations',
  'feature.boldText': 'Font weight',
  'feature.lineHeight': 'Line height',
  'feature.textSpacing': 'Letter spacing',
  'feature.textAlign': 'Text align',
  'feature.dyslexiaFont': 'Dyslexia font',
  'feature.contrast': 'Contrast',
  'feature.saturation': 'Saturation',
  'feature.hideImages': 'Hide images',
  'feature.highlightHeadings': 'Highlight titles',
  'feature.focusHighlight': 'Super focus',
  'feature.bigCursor': 'Big cursor',
  'feature.voiceNavigation': 'Voice navigation',
  'feature.voiceNavigationNote':
    'Your browser sends what you say to its own speech service. Pulxon never receives it.',
  'feature.readingMask': 'Reading mask',
  'feature.readingGuide': 'Reading guide',
  'feature.readAloud': 'Read aloud',
  'feature.dictionary': 'Dictionary',
  'feature.dictionaryLookup': 'Look up this word',
  'feature.dictionaryNote': 'Opens the Wiktionary entry in a new tab. Pulxon looks up nothing itself.',
  'level.off': 'Off',
  'level.of': 'Level {current} of {total}',
  'level.left': 'Left',
  'level.right': 'Right',
  'level.center': 'Center',
  'level.justify': 'Justify',
  'level.invert': 'Inverted',
  'level.dark': 'Dark',
  'level.light': 'Light',
  'level.low': 'Low',
  'level.high': 'High',
  'level.grayscale': 'Grayscale',
  'level.normal': 'Normal',
  'level.fast': 'Fast',
  'level.slow': 'Slow',
  'mode.monochrome': 'Monochrome',
  'mode.lowSaturation': 'Low saturation',
  'mode.highSaturation': 'High saturation',
  'mode.highContrast': 'High contrast',
  'mode.lightContrast': 'Light contrast',
  'mode.darkContrast': 'Dark contrast',
  'mode.invert': 'Invert colors',
  'fontSize.label': 'Adjust font size',
  'fontSize.decrease': 'Decrease font size',
  'fontSize.increase': 'Increase font size',
  'tool.pageStructure': 'Page structure',
  'structure.back': 'Back to settings',
  'structure.headings': 'Headings',
  'structure.landmarks': 'Landmarks',
  'structure.links': 'Links',
  'structure.empty': 'Nothing found on this page',
  'landmark.banner': 'Header',
  'landmark.navigation': 'Navigation',
  'landmark.main': 'Main content',
  'landmark.complementary': 'Complementary',
  'landmark.contentinfo': 'Footer',
  'landmark.search': 'Search',
  'landmark.region': 'Region',
  'landmark.form': 'Form',
  'profile.lowVision': 'Low vision',
  'profile.dyslexia': 'Dyslexia',
  'profile.adhd': 'ADHD friendly',
  'profile.seizureSafe': 'Reduce motion and color',
  'profile.keyboard': 'Keyboard navigation',
  'profile.cognitive': 'Cognitive & learning',
  'profileDesc.lowVision': 'Bigger text, stronger contrast and a big cursor.',
  'profileDesc.dyslexia': 'A dyslexia font with more space between letters.',
  'profileDesc.adhd': 'A reading mask, stopped animations and softer colors.',
  'profileDesc.seizureSafe': 'Stops animations and tones colors down.',
  'profileDesc.keyboard': 'A clear focus outline and highlighted links.',
  'profileDesc.cognitive': 'More line height, a reading guide and highlighted titles.',
  'settings.language': 'Language',
  'settings.languageAuto': 'Match this site',
  'settings.size': 'Size',
  'settings.sizeNormal': 'Normal',
  'settings.sizeLarge': 'Large',
  'settings.position': 'Position',
  'position.left': 'Left',
  'position.center': 'Center',
  'position.right': 'Right',
  'position.bottomLeft': 'Bottom left',
  'position.bottomCenter': 'Bottom center',
  'position.bottomRight': 'Bottom right',
} as const;
